import { useConfig, usePageVariation } from 'providers/AnalyticsProvider'
import { handleTrackAndReactEvent } from 'utils/analytics'
import { useAnalyticsTrackEvent } from 'hooks/useAnalyticsTrackEvent'
import styles from './TrackingWrapper.module.scss'
import { ACX_CHATBOT } from 'constants/featureToggles'
import { OFF_EXPERIMENT, UNASSIGNED_EXPERIMENT } from 'constants/experiments'
import { isFdrGetStartedRoute, isGetStartedRoute } from 'utils/validations/isRoutes'
import { createExperimentObject } from 'utils/experiments'
import { useAppRouter } from 'hooks/useAppRouter/useAppRouter'
import { CHATBOT_ANALYTICS_MAPPING } from '@/constants'
import { getFeatureFlag } from '@/utils/featureFlags'

function TrackingWrapper({
  track,
  siteEnv: siteEnvProp,
  onClick,
  withNextLink,
  children,
  trackAsConversion = false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mobileVariant,
  ...props
}) {
  const { config } = useConfig()
  const { pageVariation } = usePageVariation()
  const { analyticsTrackEvent } = useAnalyticsTrackEvent()
  const { asPath } = useAppRouter()
  let url = asPath
  const siteEnv =
    siteEnvProp || config?.NEXT_PUBLIC_SITE_ENVIRONMENT || process.env.NEXT_PUBLIC_SITE_ENVIRONMENT
  const localClickHandler = (event, track, onClick, withNextLink, trackAsConversion) => {
    const getTrackingObject = (track) => {
      // use experiments array if it exists, otherwise create it empty one
      track.experiments = Array.isArray(track.experiments) ? track.experiments : []
      //only add experiments to the track if the href is get-started or section has an experiment configured
      if (
        isGetStartedRoute(track?.href) ||
        isGetStartedRoute(track?.click_url) ||
        trackAsConversion ||
        Boolean(track?.sectionVariationObject?.variant)
      ) {
        // Page section level experiment
        if (track.sectionVariationObject?.variant) {
          track.experiments.push(
            createExperimentObject(
              track.sectionVariationObject?.name,
              track.sectionVariationObject?.featureFlagId,
              track.sectionVariationObject?.variant,
              'conversion'
            )
          )
        }
        // Page level variation experiment
        if (
          pageVariation &&
          pageVariation?.id &&
          pageVariation?.id !== track.sectionVariationObject?.featureFlagId
        ) {
          track.experiments.push(
            createExperimentObject(
              pageVariation?.name,
              pageVariation?.id,
              pageVariation?.variation,
              'conversion'
            )
          )
        }
      }

      //ACX_CHATBOT
      const chatbotVariation = getFeatureFlag(ACX_CHATBOT)
      if (chatbotVariation && ![OFF_EXPERIMENT, UNASSIGNED_EXPERIMENT].includes(chatbotVariation)) {
        if (
          isGetStartedRoute(track?.href, 'includes') ||
          isGetStartedRoute(track?.click_url, 'includes') ||
          isFdrGetStartedRoute(track?.href)
        ) {
          track.experiments.push(
            createExperimentObject(
              CHATBOT_ANALYTICS_MAPPING[siteEnv],
              ACX_CHATBOT,
              chatbotVariation,
              'conversion'
            )
          )
        }
      }

      delete track.sectionVariationObject

      if (track?.click_type) {
        const trackData = {
          ...track,
          click_text: track.click_text
            ? track.click_text
            : `${config.NEXT_PUBLIC_ANALYTICS_APP_NAME} | ${track.click_id}`,
        }

        if (track?.href) {
          if (track?.href.substring(0, 1) == '#') {
            trackData['click_url'] = url
          } else {
            trackData['click_url'] = `${track.href}`
          }
        }
        return trackData
      } else {
        return track
      }
    }
    if (withNextLink) {
      event.stopPropagation()
      event.preventDefault()
    }

    analyticsTrackEvent(handleTrackAndReactEvent(event, getTrackingObject(track), onClick))
  }

  return (
    <span
      className={styles['wrapper']}
      {...props}
      onClick={(event) => {
        localClickHandler(event, track, onClick, withNextLink, trackAsConversion)
      }}
      data-testid="tracking-wrapper"
    >
      <>{children}</>
    </span>
  )
}

export { TrackingWrapper }
